import React from 'react';
import { useTranslation } from 'react-i18next';
import { TypeOffre } from '../../../hooks';
import { Typography, Variant } from '../../../styles';

interface TitreToleranceVariationProps {
    cssClasse: string;
}

export const TitreToleranceVariation: React.FC<
    TitreToleranceVariationProps
> = ({ cssClasse }) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    return (
        <Typography className={cssClasse} variant={Variant.h3}>
            {t('titreSectionToleranceVariations')}
        </Typography>
    );
};

interface TextToleranceVariationProps {
    typeOffre: TypeOffre;
}

export const TextToleranceVariation: React.FC<TextToleranceVariationProps> = ({
    typeOffre
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    switch (typeOffre) {
        case TypeOffre.UN_ANS_FIXE_FERME:
        case TypeOffre.DEUX_ANS_FIXE_FERME:
        case TypeOffre.TRENTE_MOIS_FIXE_FERME:
        case TypeOffre.TROIS_ANS_FIXE_FERME:
            return (
                <Typography variant={Variant.p}>
                    {t('toleranceModereeElevee')}
                </Typography>
            );
        case TypeOffre.TRENTENEUF_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_DEUX_MOIS_FIXE_FERME:
        case TypeOffre.QUATRE_ANS_FIXE_FERME:
            return (
                <Typography variant={Variant.p}>
                    {t('toleranceModeree')}
                </Typography>
            );
        case TypeOffre.CINQUANTE_CINQ_MOIS_FIXE_FERME:
        case TypeOffre.CINQ_ANS_FIXE_FERME:
        case TypeOffre.SEPT_ANS_FIXE_FERME:
            return (
                <Typography variant={Variant.p}>
                    {t('toleranceFaible')}
                </Typography>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
            return (
                <Typography variant={Variant.p}>
                    {t('toleranceElevee')}
                </Typography>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return (
                <Typography variant={Variant.p}>
                    {t('toleranceModeree')}
                </Typography>
            );
        default:
            return <></>;
    }
};
